import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  currentQuestion: null,
  isShowHeaderBtn: false,
  isDisableReply: true,
  isOpenSubTitle: false,
  currentTimeAudio: 0,
  audioUrl: null,
  statusHeaderBtn: null,
}

export const reviseSlice = createSlice({
  name: 'revise',
  initialState,
  reducers: {
    updateCurrentQuestion: (state, action) => {
      state.currentQuestion = action.payload
    },
    updateIsShowHeaderBtn: (state, action) => {
      state.isShowHeaderBtn = action.payload
    },
    updateIsDisableReply: (state, action) => {
      state.isDisableReply = action.payload
    },
    updateIsOpenSubTitle: (state, action) => {
      state.isOpenSubTitle = action.payload
    },
    updateCurrentTimeAudio: (state, action) => {
      state.currentTimeAudio = action.payload
    },
    updateAudioUrl: (state, action) => {
      state.audioUrl = action.payload
    },
    updateStatusHeaderBtn: (state, action) => {
      state.statusHeaderBtn = action.payload
    },
    reset: () => {
      return initialState
    },
  },
})

export const {
  updateCurrentQuestion,
  updateIsShowHeaderBtn,
  updateIsDisableReply,
  updateIsOpenSubTitle,
  updateCurrentTimeAudio,
  updateAudioUrl,
  updateStatusHeaderBtn,
  reset,
} = reviseSlice.actions

export default reviseSlice.reducer
